import React, { useState } from 'react';
import { Button, Loader } from '@wix/design-system';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './HeroCard.css';
export const HeroCtaButton = _ref => {
  let {
    onClick,
    disabled = false,
    size = 'medium',
    priority = 'primary',
    fullWidth = false,
    dataHook
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const [isClickLoading, setIsClickLoading] = useState(false);
  const isPrimary = priority === 'primary';
  const handleClick = async () => {
    if (!onClick) {
      return;
    }
    setIsClickLoading(true);
    try {
      await onClick();
    } finally {
      setIsClickLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement(Button, {
    size: size,
    priority: priority,
    skin: "dark",
    fullWidth: fullWidth,
    className: [s.HeroGetItButton, isPrimary && s.HeroGetItButtonPrimary, fullWidth && s.stackedCta].filter(Boolean).join(' '),
    disabled: disabled || isClickLoading,
    onClick: handleClick,
    dataHook: dataHook
  }, isClickLoading ? /*#__PURE__*/React.createElement(Loader, {
    size: "tiny"
  }) : t('domain_search_gate.results.hero.cta.make_it_yours'));
};
//# sourceMappingURL=HeroCtaButton.js.map